import { render } from "./ui-input.vue?vue&type=template&id=2fc36d92&scoped=true"
import script from "./ui-input.vue?vue&type=script&lang=js"
export * from "./ui-input.vue?vue&type=script&lang=js"

import "./ui-input.vue?vue&type=style&index=0&id=2fc36d92&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc36d92"]])

export default __exports__